import React from 'react';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { Field } from 'formik';
import Avatar from '@/components/atoms/Avatar/Avatar';
import { getPictureSource } from '@/components/utils/card';
import Checkbox from '@/components/molecules/Formik/Checkbox';

const ShareThirdPartyAction = ({ fullPharmacyInfo }) => {
  return (
    <div className="popup-select--item with-avatar with-checkbox">
      <Avatar
        source={getPictureSource(fullPharmacyInfo as CardHcd)}
        size="small"
        type={fullPharmacyInfo?.type as any}
      />
      <p>
        <strong>{fullPharmacyInfo?.name}</strong>
      </p>
      <Field component={Checkbox} name="sharedThirdParty" />
    </div>
  );
};
export default ShareThirdPartyAction;
